export const colors = {
    // PRIMARY (BRAND)
    // Primary is old colors, kept for now. It is used in DNAChip/light.json
    'primary-100': '#DAF8FD',
    'primary-200': '#B6EEFB',
    'primary-300': '#8FDAF3',
    'primary-400': '#70C3E8',
    'primary-500': '#44A2DA',
    'primary-600': '#317FBB',
    'primary-700': '#22609C',
    'primary-800': '#15447E',
    'primary-900': '#0D3068',
    'primary-transparent-100': 'rgba(68, 162, 218, 0.08)',
    'primary-transparent-200': 'rgba(68, 162, 218, 0.16)',
    'primary-transparent-300': 'rgba(68, 162, 218, 0.24)',
    'primary-transparent-400': 'rgba(68, 162, 218, 0.32)',
    'primary-transparent-500': 'rgba(68, 162, 218, 0.4)',
    'primary-transparent-600': 'rgba(68, 162, 218, 0.48)',
    // BRAND1
    'brand1-900': '#2F143D',
    'brand1-800': '#371847',
    'brand1-700': '#3F1B51',
    'brand1-600': '#471F5B',
    'brand1-500': '#4F2265',
    'brand1-400': '#613874',
    'brand1-300': '#724E84',
    'brand1-200': '#846493',
    'brand1-100': '#957AA3',
    'brand1-80': '#A791B2',
    'brand1-50': '#B9A7C1',
    'brand1-20': '#CABDD1',
    'brand1-10': '#DCD3E0',
    'brand1-5': '#EDE9F0',
    'brand1-transparent-40': 'rgba(79, 34, 101, 0.4)',
    'brand1-transparent-56': 'rgba(79, 34, 101, 0.56)',
    // BRAND2
    'brand2-900': '#22516D',
    'brand2-800': '#296183',
    'brand2-700': '#3682AE',
    'brand2-600': '#3D92C4',
    'brand2-500': '#44A2DA',
    'brand2-400': '#57ABDE',
    'brand2-300': '#69B5E1',
    'brand2-200': '#7CBEE5',
    'brand2-100': '#8FC7E9',
    'brand2-80': '#A2D1ED',
    'brand2-50': '#B4DAF0',
    'brand2-20': '#C7E3F4',
    'brand2-10': '#DAECF8',
    'brand2-5': '#ECF6FB',
    'brand2-transparent-40': 'rgba(68, 162, 218, 0.4)',
    'brand2-transparent-56': 'rgba(68, 162, 218, 0.56)',
    // TEXT COLORS
    // (This is the old colors, we will replace it for a text-color-update ticket)
    'text-primary': '#312039',
    'text-secondary': '#766A7B',
    'text-subtle': '#BAB5BD',
    'text-basic': '#FFFFFF',
    // // TEXT COLORS (This is the new color)
    // 'text-primary': '#1D1D1D',
    // 'text-secondary': '#494949',
    'text-tertiary': '#6D6D6D',
    // 'text-subtle': '#929292',
    'text-extra-subtle': '#B6B6B6',
    'text-white': '#FFFFFF',
    // GRAY
    'gray-900': '#0F0F0F',
    'gray-800': '#1D1D1D',
    'gray-700': '#2C2C2C',
    'gray-600': '#3A3A3A',
    'gray-500': '#494949',
    'gray-400': '#6D6D6D',
    'gray-300': '#929292',
    'gray-200': '#B6B6B6',
    'gray-100': '#DBDBDB',
    'gray-80': '#EBEBEB',
    'gray-50': '#F1F1F1',
    'gray-20': '#F4F4F4',
    'gray-10': '#F8F8F8',
    'gray-5': '#FCFCFC',
    'gray-transparent-40': 'rgba(73, 73, 73, 0.4)',
    'gray-transparent-56': 'rgba(73, 73, 73, 0.56)',
    'black': '#000000',
    'black-transparent-40': 'rgba(0, 0, 0, 0.4)',
    'black-transparent-56': 'rgba(0, 0, 0, 0.56)',
    // INFO
    'info-900': '#1F4C71',
    'info-800': '#245984',
    'info-700': '#296697',
    'info-600': '#2E72AA',
    'info-500': '#337FBD',
    'info-400': '#478CC4',
    'info-300': '#5C99CA',
    'info-200': '#70A5D1',
    'info-100': '#85B2D7',
    'info-80': '#99BFDE',
    'info-50': '#ADCCE5',
    'info-20': '#C2D9EB',
    'info-10': '#D6E5F2',
    'info-5': '#EBF2F8',
    'info-transparent-40': 'rgba(51, 127, 189, 0.4)',
    'info-transparent-56': 'rgba(51, 127, 189, 0.56)',
    // SUCCESS
    'success-900': '#1D684C',
    'success-800': '#227959',
    'success-700': '#268A66',
    'success-600': '#2B9C72',
    'success-500': '#30AD7F',
    'success-400': '#45B58C',
    'success-300': '#59BD99',
    'success-200': '#6EC6A5',
    'success-100': '#83CEB2',
    'success-80': '#98D6BF',
    'success-50': '#ACDECC',
    'success-20': '#C1E6D9',
    'success-10': '#D6EFE5',
    'success-5': '#EAF7F2',
    'success-transparent-40': 'rgba(48, 173, 127, 0.4)',
    'success-transparent-56': 'rgba(48, 173, 127, 0.56)',
    // WARNING
    'warning-900': '#93611F',
    'warning-800': '#AC7124',
    'warning-700': '#C48129',
    'warning-600': '#DD912E',
    'warning-500': '#F5A133',
    'warning-400': '#F6AA47',
    'warning-300': '#F7B45C',
    'warning-200': '#F8BD70',
    'warning-100': '#F9C785',
    'warning-80': '#FAD099',
    'warning-50': '#FBD9AD',
    'warning-20': '#FCE3C2',
    'warning-10': '#FDECD6',
    'warning-5': '#FEF6EB',
    'warning-transparent-40': 'rgba(245, 161, 51, 0.4)',
    'warning-transparent-56': 'rgba(245, 161, 51, 0.56)',
    // DANGER
    'danger-900': '#7A221D',
    'danger-800': '#8E2722',
    'danger-700': '#A22D27',
    'danger-600': '#B7322C',
    'danger-500': '#CB3831',
    'danger-400': '#D04C46',
    'danger-300': '#D5605A',
    'danger-200': '#DB746F',
    'danger-100': '#E08883',
    'danger-80': '#E59C98',
    'danger-50': '#EAAFAD',
    'danger-20': '#EFC3C1',
    'danger-10': '#F5D7D6',
    'danger-5': '#FAEBEA',
    'danger-transparent-40': 'rgba(203, 56, 49, 0.4)',
    'danger-transparent-56': 'rgba(203, 56, 49, 0.56)',
    // MISC
    'notation-yellow-dot': '#FFE81E',
};
// Prefix `color-`
export default Object
    .entries(colors)
    .reduce((acc, [key, val]) => ({ ...acc, [`color-${key}`]: val }), {});
//# sourceMappingURL=colors.js.map